export default __webpack_public_path__ + "static/media/image 13.a6836e1d1e3f57504d9f80b6f8de632d.svg";